/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

// Insert any custom theme js here...

document.addEventListener('DOMContentLoaded', function() {
  const productJson = document.querySelectorAll('[id^=ProductJson-');

  if (productJson.length > 0) {
    for (let i = 0; i < productJson.length; i++) {
      const current = productJson[i];
      const sectionId = current.id.replace('ProductJson-', '');
      const section = document.querySelector('[data-section-id="' + sectionId + '"]');
      const product = JSON.parse(current.text);

      if (product.options.length === 1) {
        const unavailableVariants = [];

        for (let j = 0; j < product.variants.length; j++) {
          const variant = product.variants[j];

          if (!variant.available) {
            unavailableVariants.push(variant);
          }
        }

        if (unavailableVariants.length > 0) {
          const mutationCallback = function() {
            const variantOptions = section.querySelectorAll('.single-option-selector option');

            if (variantOptions.length > 0) {
              for (let k = 0; k < unavailableVariants.length; k++) {
                const unavailableVariant = unavailableVariants[k];

                for (let l = 0; l < variantOptions.length; l++) {
                  const option = variantOptions[l];

                  if (unavailableVariant.title === option.value) {
                    option.remove();
                  }
                }
              }

              if (typeof observer === 'object' && typeof observer.disconnect === 'function') {
                observer.disconnect();
              }
            }
          }

          const observer = new MutationObserver(mutationCallback);
          const addToCartForm = document.querySelector('form[action*="/cart/add"]');

          mutationCallback();

          if (window.MutationObserver && addToCartForm.length) {
            const config = { childList: true, subtree: true };

            if (typeof observer === 'object' && typeof observer.disconnect === 'function') {
              observer.disconnect();
            }

            observer.observe(addToCartForm, config);
          }
        }
      }
    }
  }
});

/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/
var Shopify = Shopify || {};
// ---------------------------------------------------------------------------
// Money format handler
// ---------------------------------------------------------------------------
Shopify.money_format = "${{amount}}";
Shopify.formatMoney = function(cents, format) {
    if (typeof cents == 'string') {
        cents = cents.replace('.', '');
    }
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = (format || this.money_format);

    function defaultOption(opt, def) {
        return (typeof opt == 'undefined' ? def : opt);
    }

    function formatWithDelimiters(number, precision, thousands, decimal) {
        precision = defaultOption(precision, 2);
        thousands = defaultOption(thousands, ',');
        decimal = defaultOption(decimal, '.');
        if (isNaN(number) || number == null) {
            return 0;
        }
        number = (number / 100.0).toFixed(precision);
        var parts = number.split('.'),
            dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
            cents = parts[1] ? (decimal + parts[1]) : '';
        return dollars + cents;
    }
    switch (formatString.match(placeholderRegex)[1]) {
        case 'amount':
            value = formatWithDelimiters(cents, 2);
            break;
        case 'amount_no_decimals':
            value = formatWithDelimiters(cents, 0);
            break;
        case 'amount_with_comma_separator':
            value = formatWithDelimiters(cents, 2, '.', ',');
            break;
        case 'amount_no_decimals_with_comma_separator':
            value = formatWithDelimiters(cents, 0, '.', ',');
            break;
    }
    return formatString.replace(placeholderRegex, value);
};
// Insert any custom theme js here...

function initCustomSubscription() {
  $('.js-subscribe-custom-item').on('click', function(){
    var $this = $(this);

    $this.siblings().removeClass('is-active');
    $this.addClass('is-active');
  })
}

function playVideo(el, iframeUrl) {
  if (!el || !iframeUrl) return;
  var container = el.nodeType === 1 ? el : el[0];
  if (!container || !container.appendChild) return;

  var html = String(iframeUrl).trim();
  var tmp = document.createElement('div');
  tmp.innerHTML = html;
  var iframe = tmp.querySelector('iframe');

  if (!iframe && html.indexOf('<') === -1) {
    var tx = document.createElement('textarea');
    tx.innerHTML = html;
    tmp.innerHTML = tx.value.trim();
    iframe = tmp.querySelector('iframe');
  }

  if (iframe) {
    container.appendChild(iframe);
    return;
  }

  if (/^https?:\/\//i.test(html)) {
    iframe = document.createElement('iframe');
    iframe.src = html;
    iframe.setAttribute('frameborder', '0');
    iframe.setAttribute('allow', 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share');
    iframe.setAttribute('allowfullscreen', '');
    container.appendChild(iframe);
  }
}

function removeCountrySelectorPopup() {
    var urlParams = new URLSearchParams(window.location.search); 
    var isCountryParamAdded = urlParams.get('country');

    if(isCountryParamAdded) { //check if foo parameter is set to anything
        $('body').addClass('is-country-popup-disabled');
    }
}

function initVariantImageChange() {
  // Change variant images
  $('.js-main-selector').find('label').on('click', function(){
    var $this = $(this),
        $productImages = $('#productVariantImages'),
        newOption1 = $this.data('option-1');

    $('.js-secondary-selector').find('label').each(function(){
      var $label = $(this),
          $image = $(this).find('.variant-image'),
          option2 = $label.data('option-2'),
          newImageSrc = $('#productVariantImages').find('div[data-option="' + newOption1 + ' ' + option2 +'"]').data('image');

      $image.attr('src', newImageSrc);
    })
    
  });
}

function initSubfoldersRedirects() {
  var currentUrl = window.location.href,
      subfoldersList = ['/en-AB','/en-AC','/en-AD','/en-AE','/en-AF','/en-AG','/en-AH','/en-AI','/en-AJ','/en-AK','/en-AL','/en-AM','/en-AN','/en-AO','/en-AP','/en-AQ','/en-AR','/en-AS','/en-AT','/en-AU','/en-AV','/en-AW','/en-AX','/en-AY','/en-AZ','/en-BB','/en-BC','/en-BD','/en-BE','/en-BF','/en-BG','/en-BH','/en-BI','/en-BJ','/en-BK','/en-BL','/en-BM','/en-BN','/en-BO','/en-BP','/en-BQ','/en-BR','/en-BS','/en-BT','/en-BU','/en-BV','/en-BW','/en-BX','/en-BY','/en-BZ','/en-CB','/en-CC','/en-CD','/en-CE','/en-CF','/en-CG','/en-CH','/en-CI','/en-CJ','/en-CK','/en-CL','/en-CM','/en-CN','/en-CO','/en-CP','/en-CQ','/en-CR','/en-CS','/en-CT','/en-CU','/en-CV','/en-CW','/en-CX','/en-CY','/en-CZ','/en-DB','/en-DC','/en-DD','/en-DE','/en-DF','/en-DG','/en-DH','/en-DI','/en-DJ','/en-DK','/en-DL','/en-DM','/en-DN','/en-DO','/en-DP','/en-DQ','/en-DR','/en-DS','/en-DT','/en-DU','/en-DV','/en-DW','/en-DX','/en-DY','/en-DZ','/en-EB','/en-EC','/en-ED','/en-EE','/en-EF','/en-EG','/en-EH','/en-EI','/en-EJ','/en-EK','/en-EL','/en-EM','/en-EN','/en-EO','/en-EP','/en-EQ','/en-ER','/en-ES','/en-ET','/en-EU','/en-EV','/en-EW','/en-EX','/en-EY','/en-EZ','/en-FB','/en-FC','/en-FD','/en-FE','/en-FF','/en-FG','/en-FH','/en-FI','/en-FJ','/en-FK','/en-FL','/en-FM','/en-FN','/en-FO','/en-FP','/en-FQ','/en-FR','/en-FS','/en-FT','/en-FU','/en-FV','/en-FW','/en-FX','/en-FY','/en-FZ','/en-GB','/en-GC','/en-GD','/en-GE','/en-GF','/en-GG','/en-GH','/en-GI','/en-GJ','/en-GK','/en-GL','/en-GM','/en-GN','/en-GO','/en-GP','/en-GQ','/en-GR','/en-GS','/en-GT','/en-GU','/en-GV','/en-GW','/en-GX','/en-GY','/en-GZ','/en-HB','/en-HC','/en-HD','/en-HE','/en-HF','/en-HG','/en-HH','/en-HI','/en-HJ','/en-HK','/en-HL','/en-HM','/en-HN','/en-HO','/en-HP','/en-HQ','/en-HR','/en-HS','/en-HT','/en-HU','/en-HV','/en-HW','/en-HX','/en-HY','/en-HZ','/en-IB','/en-IC','/en-ID','/en-IE','/en-IF','/en-IG','/en-IH','/en-II','/en-IJ','/en-IK','/en-IL','/en-IM','/en-IN','/en-IO','/en-IP','/en-IQ','/en-IR','/en-IS','/en-IT','/en-IU','/en-IV','/en-IW','/en-IX','/en-IY','/en-IZ','/en-JB','/en-JC','/en-JD','/en-JE','/en-JF','/en-JG','/en-JH','/en-JI','/en-JJ','/en-JK','/en-JL','/en-JM','/en-JN','/en-JO','/en-JP','/en-JQ','/en-JR','/en-JS','/en-JT','/en-JU','/en-JV','/en-JW','/en-JX','/en-JY','/en-JZ','/en-KB','/en-KC','/en-KD','/en-KE','/en-KF','/en-KG','/en-KH','/en-KI','/en-KJ','/en-KK','/en-KL','/en-KM','/en-KN','/en-KO','/en-KP','/en-KQ','/en-KR','/en-KS','/en-KT','/en-KU','/en-KV','/en-KW','/en-KX','/en-KY','/en-KZ','/en-LB','/en-LC','/en-LD','/en-LE','/en-LF','/en-LG','/en-LH','/en-LI','/en-LJ','/en-LK','/en-LL','/en-LM','/en-LN','/en-LO','/en-LP','/en-LQ','/en-LR','/en-LS','/en-LT','/en-LU','/en-LV','/en-LW','/en-LX','/en-LY','/en-LZ','/en-MB','/en-MC','/en-MD','/en-ME','/en-MF','/en-MG','/en-MH','/en-MI','/en-MJ','/en-MK','/en-ML','/en-MM','/en-MN','/en-MO','/en-MP','/en-MQ','/en-MR','/en-MS','/en-MT','/en-MU','/en-MV','/en-MW','/en-MX','/en-MY','/en-MZ','/en-NB','/en-NC','/en-ND','/en-NE','/en-NF','/en-NG','/en-NH','/en-NI','/en-NJ','/en-NK','/en-NL','/en-NM','/en-NN','/en-NO','/en-NP','/en-NQ','/en-NR','/en-NS','/en-NT','/en-NU','/en-NV','/en-NW','/en-NX','/en-NY','/en-NZ','/en-OB','/en-OC','/en-OD','/en-OE','/en-OF','/en-OG','/en-OH','/en-OI','/en-OJ','/en-OK','/en-OL','/en-OM','/en-ON','/en-OO','/en-OP','/en-OQ','/en-OR','/en-OS','/en-OT','/en-OU','/en-OV','/en-OW','/en-OX','/en-OY','/en-OZ','/en-PB','/en-PC','/en-PD','/en-PE','/en-PF','/en-PG','/en-PH','/en-PI','/en-PJ','/en-PK','/en-PL','/en-PM','/en-PN','/en-PO','/en-PP','/en-PQ','/en-PR','/en-PS','/en-PT','/en-PU','/en-PV','/en-PW','/en-PX','/en-PY','/en-PZ','/en-QB','/en-QC','/en-QD','/en-QE','/en-QF','/en-QG','/en-QH','/en-QI','/en-QJ','/en-QK','/en-QL','/en-QM','/en-QN','/en-QO','/en-QP','/en-QQ','/en-QR','/en-QS','/en-QT','/en-QU','/en-QV','/en-QW','/en-QX','/en-QY','/en-QZ','/en-RB','/en-RC','/en-RD','/en-RE','/en-RF','/en-RG','/en-RH','/en-RI','/en-RJ','/en-RK','/en-RL','/en-RM','/en-RN','/en-RO','/en-RP','/en-RQ','/en-RR','/en-RS','/en-RT','/en-RU','/en-RV','/en-RW','/en-RX','/en-RY','/en-RZ','/en-SB','/en-SC','/en-SD','/en-SE','/en-SF','/en-SG','/en-SH','/en-SI','/en-SJ','/en-SK','/en-SL','/en-SM','/en-SN','/en-SO','/en-SP','/en-SQ','/en-SR','/en-SS','/en-ST','/en-SU','/en-SV','/en-SW','/en-SX','/en-SY','/en-SZ','/en-TB','/en-TC','/en-TD','/en-TE','/en-TF','/en-TG','/en-TH','/en-TI','/en-TJ','/en-TK','/en-TL','/en-TM','/en-TN','/en-TO','/en-TP','/en-TQ','/en-TR','/en-TS','/en-TT','/en-TU','/en-TV','/en-TW','/en-TX','/en-TY','/en-TZ','/en-UB','/en-UC','/en-UD','/en-UE','/en-UF','/en-UG','/en-UH','/en-UI','/en-UJ','/en-UK','/en-UL','/en-UM','/en-UN','/en-UO','/en-UP','/en-UQ','/en-UR','/en-US','/en-UT','/en-UU','/en-UV','/en-UW','/en-UX','/en-UY','/en-UZ','/en-VB','/en-VC','/en-VD','/en-VE','/en-VF','/en-VG','/en-VH','/en-VI','/en-VJ','/en-VK','/en-VL','/en-VM','/en-VN','/en-VO','/en-VP','/en-VQ','/en-VR','/en-VS','/en-VT','/en-VU','/en-VV','/en-VW','/en-VX','/en-VY','/en-VZ','/en-WB','/en-WC','/en-WD','/en-WE','/en-WF','/en-WG','/en-WH','/en-WI','/en-WJ','/en-WK','/en-WL','/en-WM','/en-WN','/en-WO','/en-WP','/en-WQ','/en-WR','/en-WS','/en-WT','/en-WU','/en-WV','/en-WW','/en-WX','/en-WY','/en-WZ','/en-XB','/en-XC','/en-XD','/en-XE','/en-XF','/en-XG','/en-XH','/en-XI','/en-XJ','/en-XK','/en-XL','/en-XM','/en-XN','/en-XO','/en-XP','/en-XQ','/en-XR','/en-XS','/en-XT','/en-XU','/en-XV','/en-XW','/en-XX','/en-XY','/en-XZ','/en-YB','/en-YC','/en-YD','/en-YE','/en-YF','/en-YG','/en-YH','/en-YI','/en-YJ','/en-YK','/en-YL','/en-YM','/en-YN','/en-YO','/en-YP','/en-YQ','/en-YR','/en-YS','/en-YT','/en-YU','/en-YV','/en-YW','/en-YX','/en-YY','/en-YZ','/en-ZB','/en-ZC','/en-ZD','/en-ZE','/en-ZF','/en-ZG','/en-ZH','/en-ZI','/en-ZJ','/en-ZK','/en-ZL','/en-ZM','/en-ZN','/en-ZO','/en-ZP','/en-ZQ','/en-ZR','/en-ZS','/en-ZT','/en-ZU','/en-ZV','/en-ZW','/en-ZX','/en-ZY','/en-ZZ'];

  
  $.each(subfoldersList, function( index, value ) {
    var lowerCaseValue = value.toLowerCase();
    if (currentUrl.indexOf(lowerCaseValue) > -1) {
      var newRedirectUrl = currentUrl.replace(lowerCaseValue, '');
      window.location.replace(newRedirectUrl);
    }
  });
}

$(document).ready(function() {
    $('.js-collection-faq-toggle').on('click', function() {
      $(this).parent().toggleClass('is-active');
    })
    $('.product-form__quantity-selector').click(function(event) {
        event.stopPropagation();
        event.preventDefault();
    });
    $('.product-card-addtocart').click(function(event) {
        refreshCart();
        $(document).on('drawer_open_start', function() {
            $('.product-form>.btn').addClass('btn--primary');
            $('.product-form>.btn').removeClass('btn--secondary');
            $('.product-form>.btn').removeClass('btn--to-secondary-transitioned');
            $('.product-form>.btn .primary-text').show();
            $('.product-form>.btn .secondary-text').hide();
            $('.product-form>p').removeClass('product__notification--success')
            $('.product-form>.btn').removeClass("ajax-cart__toggle");
        });
        $('.cart-drawer__checkout').prop("disabled", false);
    });

    $('.js-accordion-toggle').on('click', function(){
      $(this).parent().toggleClass('is-active');
    })

    if ($('.content-reviews-carousel').length > 0) {
       $('.content-reviews-carousel').owlCarousel({
          loop:true,
          margin:10,
          nav:true,
          responsive:{
              0:{
                  items:1
              },
              900:{
                  items:3
              },
              1000:{
                  items:4
              }
          }
      })
    }
   

    if ($('.js-content-product-carousel').length > 0) {
      $('.js-content-product-carousel').owlCarousel({
          loop:true,
          margin:10,
          dots: false,
          nav:true,
          responsive:{
              0:{
                  items:1
              },
              900:{
                  items:1
              },
              1000:{
                  items:1
              }
          }
      })
    }
    

      $('.js-contentproduct-variant').on('click', function(){
        var $this = $(this),
            id = $this.attr('data-id'),
            slideIndex = $('.js-content-product-carousel').find('img[data-id="' + id + '"').parent().index() + 1;
    
        console.log(slideIndex);
    
        $this.siblings().removeClass('is-active');
        $this.addClass('is-active');
    
        $('.js-content-product-carousel').trigger('to.owl.carousel', [slideIndex, 500, true]);// 500 is the speed of the transition in ms
      })
    
      $(".js-addtocart-submit").on("click", function (e) {
          var $this = $(this),
              $wrapper = $this.parents('.js-product-submitwrapper'),
              activeID = $wrapper.find('.js-contentproduct-variant.is-active').attr('data-id');
        
            add_items_to_cart(
              activeID, 
              1, 
              "open_slider", 
              null, 
              null
            );
        });

  $('.js-upsell-variant-changer').on('change', function(){
     var $option = $(this).find(":selected"),
         $form = $(this).parents('form'),
         $product = $(this).parents('.product'),
         id = $option.attr('data-id'),
         price = $option.attr('data-price');
    
    $product.find('.product__price').html(price);
    $form.find('input[name="id"]').val(id);
  })

  $('nav[data-site-navigation]').one('click', function () {
    if ($(window).width() >= 750) return;

    // Pre-expand the first 3 top-level sublink items on mobile, and keep
    // aria-expanded in sync so the theme's toggle handler stays consistent
    // (otherwise the first tap on one of these items appears to "do nothing"
    // because toggleClass re-collapses it).
    var $sublinkElements = $(this).find('.navigation__links').children('.navigation__has-sublinks');

    $sublinkElements.slice(0, 3)
      .removeClass('navigation__has-sublinks--collapsed')
      .children('.navigation__expand-sublinks')
      .attr('aria-expanded', 'true');
  });

  // Init functions
  removeCountrySelectorPopup();
  initVariantImageChange();
  initCustomSubscription();
  initSubfoldersRedirects();
});